import { AlertTemplateAppModel as AlertTemplateAppModel } from '../models/alert-template.app.model';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { Subject, Observable } from 'rxjs';

@Injectable()
export class AlertBoxService {
	public inputChanged$: Observable<string>;

	private inputChangeSubject: Subject<string> = new Subject();

	public constructor(public alertController: AlertController) {
		this.inputChanged$ = this.inputChangeSubject.asObservable();
	}

	public async presentAlertPrompt(alertTemplate: AlertTemplateAppModel) {
		const alert = await this.alertController.create({
			cssClass: 'alertBoxStyle',
			message: alertTemplate.message,
			inputs: [
				{
					name: alertTemplate.inputName,
					type: 'text',
					value: alertTemplate.input,
					cssClass: 'inputStyle'
				}
			],
			buttons: [
				{
					text: alertTemplate.cancelButtonLabel,
					role: 'cancel',
					cssClass: 'cancelButtonStyle',
					handler: () => {
						this.inputChangeSubject.next(alertTemplate.input);
					}
				},
				{
					text: alertTemplate.saveButtonLabel,
					cssClass: 'saveButtonStyle',
					handler: (data) => {
						//TODO: MAKE A SEPARATE METHOD FOR OBSERVABLE WHICH DOES NOT
						// SEND A STRING VALUE BUT A BOOLEAN FOR FUTURE IMPLEMENTATIONS
						this.inputChangeSubject.next(data[alertTemplate.inputName]);
					}
				}
			]
		});

		await alert.present();
	}
}
